"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Table = (0, styles_1.styled)(material_1.Table)(function (_a) {
    var theme = _a.theme;
    return ({
        tableLayout: 'fixed',
        borderCollapse: 'separate',
        backgroundColor: theme.palette.common.white,
        '&.MuiTable-stickyHeader': {
            backgroundColor: theme.palette.common.white,
        },
        '.MuiTableRow-root .MuiTableCell-body .MuiTypography-body1:first-child': {
            color: theme.palette.grey.A400,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(Table, {
    stickyHeader: true,
});
